import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { onToggleLayer } from '../../../ac/onToggleLayer';
import { setTerrainMode } from '../../../ac/setTerrainMode';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const TerrainPanelComponent = ({ displayedLayers, onToggleLayer, isTerrain3DEnabled, terrainMode, setTerrainMode }) => {
    // Only show panel if 3D terrain is enabled
    if (!isTerrain3DEnabled) {
        return null;
    }
    const isSlopeLayerVisible = displayedLayers.some(({ id }) => id === 'terrain:slope');
    const handleModeChange = ({ target: { value: newMode } }) => {
        setTerrainMode(newMode);

        if (newMode === 'off') {
            // Hide slope layer if visible
            if (isSlopeLayerVisible) {
                onToggleLayer('terrain:slope');
            }
        } else if (newMode === 'hillshade' || newMode === 'Slope' || newMode === 'aspect' || newMode === 'composite') {
            // Show slope layer if not visible
            if (!isSlopeLayerVisible) {
                onToggleLayer('terrain:slope');
            }
        }
    };
    const terrainOptions = [
        { value: 'hillshade', label: t`Теневой рельеф` },
        { value: 'Slope', label: t`Уклоны` },
        { value: 'aspect', label: t`Экспозиция` },
        { value: 'composite', label: t`Aspect with Slope` },
        { value: 'off', label: t`Отключено` },
    ];

    return (
        <div>
            <div className={styles.legHead}>
                {t`Рельеф местности`}:
            </div>
            <StandardRadioGroup
                value={terrainMode}
                onChange={handleModeChange}
            >
                {
                    terrainOptions.map(({ value, label }) => (
                        <FormControlLabel
                            key={value}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={terrainMode === value}
                                    onChange={handleModeChange}
                                    value={value}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: terrainMode === value,
                                        }
                                    )}
                                    size='small'
                                />
                            }
                            label={i18n._(label)}
                            labelPlacement='end'
                        />
                    ))
                }
            </StandardRadioGroup>
        </div>
    );
};
const mapStateToProps = ({ displayedLayers, map: { isTerrain3DEnabled, terrainMode } }) => ({ displayedLayers, isTerrain3DEnabled, terrainMode });

export const TerrainPanel = connect(
    mapStateToProps,
    { onToggleLayer, setTerrainMode }
)(TerrainPanelComponent);
